import buildMatchPatternFn from '../../../_lib/buildMatchPatternFn/index';
import buildMatchFn from '../../../_lib/buildMatchFn/index';

const matchOrdinalNumberPattern = /^(\d+)(\.)?/i;
const parseOrdinalNumberPattern = /\d+/i;

const matchEraPatterns = {
  narrow: /^(p.n.e.|n.e.)/i,
  abbreviated: /^(p.n.e.|n.e.)/i,
  wide: /^(prije nove ere|nove ere)/i,
};
const parseEraPatterns = {
  any: [/(^p\.n\.e\.|^prije nove ere)/i, /(^n\.e\.|^nove ere)/i],
};

const matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234]. tromjesečje/i,
  wide: /^[1234]. tromjesečje/i,
};
const parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i],
  abbreviated: [
    /1. tromjesečje/i,
    /2. tromjesečje/i,
    /3. tromjesečje/i,
    /4. tromjesečje/i,
  ],
  wide: [
    /1. tromjesečje/i,
    /2. tromjesečje/i,
    /3. tromjesečje/i,
    /4. tromjesečje/i,
  ],
};

const matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|maj|jun|jul|aug|sep|okt|nov|dec)/i,
  wide: /^(januar|februar|mart|april|maj|juni|juli|avgust|septembar|oktobar|novembar|decembar)/i,
};
const parseMonthPatterns = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i,
  ],
  abbreviated: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^maj/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i,
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^maj/i,
    /^jun/i,
    /^jul/i,
    /^av/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i,
  ],
};

const matchDayPatterns = {
  narrow: /^[npusč]/i,
  short: /^(ne|po|ut|sr|če|pe|su)/i,
  abbreviated: /^(ned|pon|uto|sri|čet|pet|sub)/i,
  wide: /^(nedjelja|ponedeljak|utorak|srijeda|četvrtak|petak|subota)/i,
};
const parseDayPatterns = {
  narrow: [/^n/i, /^p/i, /^u/i, /^s/i, /^č/i, /^p/i, /^s/i],
  short: [/^ne/i, /^po/i, /^ut/i, /^sr/i, /^če/i, /^pe/i, /^su/i],
  abbreviated: [/^ned/i, /^pon/i, /^uto/i, /^sri/i, /^čet/i, /^pet/i, /^sub/i],
  any: [
    /^nedjelja/i,
    /^ponedeljak/i,
    /^utorak/i,
    /^srijeda/i,
    /^četvrtak/i,
    /^petak/i,
    /^subota/i,
  ],
};

const matchDayPeriodPatterns = {
  any: /^(prijepodne|poslijepodne|ponoć|podne|jutro|večer|noć)/i,
};
const parseDayPeriodPatterns = {
  any: {
    am: /prijepodne/i,
    pm: /poslijepodne/i,
    midnight: /ponoć/i,
    noon: /podne/i,
    morning: /jutro/i,
    afternoon: /poslijepodne/i,
    evening: /večer/i,
    night: /noć/i,
  },
};

const match = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: function (value) {
      return parseInt(value, 10);
    },
  }),

  era: buildMatchFn({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns,
    defaultParseWidth: 'any',
  }),

  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: 'any',
    valueCallback: function (index) {
      return index + 1;
    },
  }),

  month: buildMatchFn({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: 'any',
  }),

  day: buildMatchFn({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns,
    defaultParseWidth: 'any',
  }),

  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: 'any',
  }),
};

export default match;
